import { render } from "./MiscMain.vue?vue&type=template&id=5006d406"
import script from "./MiscMain.vue?vue&type=script&lang=js"
export * from "./MiscMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__